import { render, staticRenderFns } from "./payNotice.vue?vue&type=template&id=0549ea22&scoped=true"
import script from "./payNotice.vue?vue&type=script&lang=js"
export * from "./payNotice.vue?vue&type=script&lang=js"
import style0 from "./payNotice.vue?vue&type=style&index=0&id=0549ea22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549ea22",
  null
  
)

export default component.exports